// extracted by mini-css-extract-plugin
export default {"buttons":"BotCard_buttons__3An4h","selectchatbutton":"BotCard_selectchatbutton__4GgQ7","container":"BotCard_container__cHaw+"};